import { graphql, useStaticQuery } from 'gatsby';
import { type WithDiscoveryPagesByTypeProps, withDiscoveryPagesByType } from '@lucid/utils';

import type { Lucid } from '../types/types';

const useDiscoveryPagesByType = ({ excludeId, discoveryTypeFilter, languageKey }: WithDiscoveryPagesByTypeProps) => {
  const {
    directus: { discovery },
  } = useStaticQuery<Lucid.Query.Hooks.UseDiscoveryPagesByType>(graphql`
    query useDiscoveryPagesByTypeQuery {
      directus {
        discovery(filter: { status: { _eq: "published" } }, limit: 1000) {
          id
          discovery_type {
            id
          }
          translations {
            languages_code {
              short_code
            }
            heading
            path {
              url
            }
          }
        }
      }
    }
  `);

  return withDiscoveryPagesByType(discovery, { excludeId, discoveryTypeFilter, languageKey });
};

export default useDiscoveryPagesByType;
